

<form edlFocusTrap [formGroup]="form" novalidate errorTailor>

    <div class="modal-body">


        <div class="card card-body p-3 mb-3" *ngIf="!busy">
            <div class="a48-header-container" style="display: flex;">
                <timetracking-status-indicator 
                        *ngIf="details!=null"
                        [statusId]="details.StatusID"
                        [a48ContextCode]="details.ContextCode"
                        [timeTrackingType]="TimeTrackingType.ACT48">
                </timetracking-status-indicator>
                <h4 class="card-title">
                    {{details.UserDisplayName}} - Submission Status
                </h4>
            </div>
            <small *ngIf="!DateHelpers.isMinDate(details.SubmissionTimeStamp)">Last Updated: {{details.SubmissionTimeStamp | date: 'medium' }}</small>
            <p class="card-text" [innerHTML]="details.Status"></p>
        </div>

        <div class="content" *ngIf="busy" >
                <div class="loader"></div>
        </div>

        <div class="row" *ngIf="!busy">
            <div class="col-sm-12" *ngIf="canDisplaySubmitHoursToggle()">
                <label class="form-label">
                    <div>Submit to PERMS </div>
                    <toggle-indicator
                        formControlName="ShouldSubmitToPerms"
                        OnLabel="Yes" OffLabel="No"></toggle-indicator>
                </label>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label class="form-label" for="ppid">PPID <span class="required">*</span></label>
                    <input type="text" maxlength="7" class="form-control" id="ppid" formControlName="PPID"
                        [attr.aria-invalid]="ppidControl?.invalid && ppidControl?.touched ? 'true' : null"
                        [attr.aria-describedby]="ppidControl?.invalid && ppidControl?.touched ? 'ppid-error' : null" />
                    <div id="ppid-error"
                         class="invalid-feedback"
                         role="alert"
                         controlErrorAnchor>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!busy">
            <div class="col-sm-12">
                <div class="form-group">
                    <label class="form-label" for="hours">
                        <span>{{a48HelpersService.getHoursOrCreditsFullLabel(userCycle.A48ActivityType)}}: </span>
                        <span class="required">*</span>
                    </label>
                    <input type="number" min="0" step="0.5" (change)="ensureGreaterThanZero()" class="form-control" id="hours" formControlName="Hours"
                        [attr.aria-invalid]="hoursControl?.invalid && hoursControl?.touched ? 'true' : null"
                        [attr.aria-describedby]="hoursControl?.invalid && hoursControl?.touched ? 'hours-error' : null" />
                    <div id="hours-error"
                         class="invalid-feedback"
                         role="alert"
                         controlErrorAnchor>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!busy">
            <div class="col-sm-12">
                <div class="form-group" >
                    <label class="form-label" id="userDate-label">
                        Submitted Date
                        <button type="button" class="btn btn-link p-0 border-0 align-baseline"
                            ngbPopover="If you set this date, you will be overriding the completed date. Normally the completed date is the default."
                            popoverTitle="Submitted Date"
                            placement="top"
                            triggers="mouseenter:mouseleave focus:blur"
                            aria-label="More information about Submitted Date">
                            <i class="fas fa-question-circle me-1" aria-hidden="true"></i>
                        </button>
                        <span *ngIf="showSubmittedDate()" class="required">*</span>
                    </label>
                    <edl-date-picker *ngIf="showSubmittedDate()" formControlName="UserDate"
                        [class.is-invalid]="userDateControl?.invalid && userDateControl?.touched"
                        [attr.aria-invalid]="userDateControl?.invalid && userDateControl?.touched ? 'true' : null"
                        [attr.aria-describedby]="userDateControl?.invalid && userDateControl?.touched ? 'userDate-error' : null"
                        [attr.aria-labelledby]="'userDate-label'"></edl-date-picker>
                    <div id="userDate-error"
                         class="error-tailor-manual"
                         *ngIf="showSubmittedDate() && userDateControl?.invalid && userDateControl?.touched"
                         role="alert">
                        This field is required.
                    </div>
                    <div *ngIf="!showSubmittedDate()">The submission will use the users completed date upon approval.</div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!busy">
            <div class="col-sm-12 small">
                <strong>Note</strong> - If a user does not have a PPID number and they are not a paraeducator, you will want to exclude them from Act 48 submssions to PERMS
                to avoid the red submission error status. To exclude a user from submissions, go to User Management, locate the user, and edit the user’s profile by selecting
                the <strong>Exclude from Act 48 Submissions</strong> option. If you do not have access to User Management, contact your portal admin.
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" *ngIf="showSaveButton()" (click)="onSubmit(form)" [disabled]="form.invalid">Save</button>
        <button type="button" class="btn btn-primary" *ngIf="showResubmitButton()" (click)="onResubmit(form)" [disabled]="form.invalid">Resubmit</button>
        <button *ngIf="canClose" type="button" class="btn btn-info" (click)="cancel()">Close</button>
    </div>
</form>
